import {
  IComboBox,
  IComboBoxOption,
  ComboBox,
  IComboBoxProps,
  IComboBoxStyles,
  IconButton,
} from '@fluentui/react';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export interface IComboBoxSearch {
  options: IComboBoxOption[];
  selected: string[];
  onSelectOption: (opt: IComboBoxOption) => void;
  comboProps?: IComboBoxProps;
  comboStyles?: IComboBoxStyles;
  className?: any;
  disabled?: boolean;
  cleanOnSelect?: boolean;
  onDelete?: () => void;
}

const useFocus = () => {
  const htmlElRef = useRef<IComboBox>(null);
  const setFocus = () => {
    htmlElRef?.current?.focus();
  };

  return [htmlElRef, setFocus];
};

export const ComboBoxSearch = (props: IComboBoxSearch) => {
  const { t, i18n } = useTranslation();
  const [inputRef, setInputFocus] = useFocus();

  const [optionsFiltered, setOptionsFiltered] = React.useState(props.options);
  const [textDropDown, setTextDropdown] = React.useState<string | undefined>(undefined);
  const [isActive, setIsActive] = React.useState<boolean>(true);
  const [selected, setSelected] = React.useState<string[]>(props.selected);

  const onInputValueChange = (value: string) => {
    let _optionsFiltered = [...props.options];
    let save = _optionsFiltered.filter((opt) =>
      opt.text.toLocaleLowerCase().includes(value.toLocaleLowerCase())
    );

    setOptionsFiltered(save);
  };

  React.useEffect(() => {
    if (props.selected[0] === '') {
      setSelected([]);
    } else {
      setSelected(props.selected);
    }
  }, [props.selected]);

  React.useEffect(() => {
    const text = props.options.find((o) => o.key === props.selected[0]);
    if (text) setTextDropdown(String(text?.key));
    else setTextDropdown('');
  }, []);

  React.useEffect(() => {
    setOptionsFiltered(props.options);
  }, [props.options]);

  const onChangeCustomInput = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => {
    if (option) {
      if (props.cleanOnSelect) {
        setTextDropdown('');
      } else {
        setTextDropdown(option.text);
      }

      if (props.cleanOnSelect) {
        setSelected(['-1']);
      } else {
        setSelected([String(option.key)]);
      }

      props.onSelectOption(option);

      destroyAndConstruct();
    }
    setOptionsFiltered(props.options);
  };

  const destroyAndConstruct = () => {
    setIsActive(false);
    setTimeout(() => {
      setIsActive(true);
    }, 50);
    setTimeout(() => {
      // @ts-ignore
      setInputFocus();
    }, 50);
  };

  return (
    <>
      {isActive && (
        <>
          {props.onDelete && (
            <IconButton
              iconProps={{ iconName: 'Cancel' }}
              onClick={props.onDelete}
              style={{
                position: 'absolute',
                zIndex: 1,
                height: 25,
                bottom: '4px ',
                right: '40px',
                color: '#f74747',
              }}
            />
          )}

          <ComboBox
            componentRef={inputRef}
            {...props.comboProps}
            selectedKey={selected}
            autoComplete="off"
            styles={{
              input: { width: props.onDelete ? '90%' : '100%', marginRight: props.onDelete ? '10%' : '0%' },
            }}
            allowFreeform
            shouldRestoreFocus={true}
            openOnKeyboardFocus={true}
            options={optionsFiltered}
            onInputValueChange={onInputValueChange}
            onChange={onChangeCustomInput}
            className={props.className}
            disabled={props.disabled}
            onBlur={() => console.log()}
          />
        </>
      )}
    </>
  );
};

export default ComboBoxSearch;
